import { useEffect, useState } from "react";
import vestelKimlik from "../assets/images/vestelKimlik.png";
import redirect1 from "../assets/images/redirect1.png";
import vestelLogo1 from "../assets/images/vestelLogo1.png";
import evinAkli1 from "../assets/images/Vestel_Akilli_Yasam_ikon_final.png";
import vfit1 from "../assets/images/Vestel_Akilli_Saglik_ikon_final.png";
import regal1 from "../assets/images/regal1.png";
import vsOutlet1 from "../assets/images/vsOutlet1.png";
import vestelCozum1 from "../assets/images/vestelCozum1.png";
import RedirectImage from "../assets/images/redirectImage.png";
import useMediaQuery from "../hooks/useMediaQuery";
import { useTranslation } from "react-i18next";
import { languagesEnum } from "../libs/enums";

export default function VestelIdentity() {
  const isSmallScreen = useMediaQuery("(max-width:785px)");
  const [evinAkli, setEvinAkli] = useState("");
  const [vfit, setVfit] = useState("");
  const { t, i18n } = useTranslation();
  const [storeUrl, setStoreUrl] = useState(
    `${process.env.REACT_APP_STORE_URL}customer/login`
  );

  const applicationList = [
    {
      href: storeUrl,
      imgSrc: vestelLogo1,
      imgAlt: "vestelLogo1",
      redirectText: t("redirect.goToWebsite"),
      redirectImgSrc: RedirectImage,
      redirectImgAlt: "redirectImage",
      visibleLanguages:[languagesEnum.TR, languagesEnum.EN, languagesEnum.DE]
    },
    {
      href: evinAkli,
      imgSrc: evinAkli1,
      imgAlt: "evinAkli1",
      imgStyle: { width: "50px" },
      text: t("redirect.smartLife"),
      redirectText: t("redirect.goToApplication"),
      redirectImgSrc: RedirectImage,
      redirectImgAlt: "redirectImage",
      visibleLanguages:[languagesEnum.TR, languagesEnum.EN, languagesEnum.DE]
    },
    {
      href: vfit,
      imgSrc: vfit1,
      imgAlt: "vfit1",
      imgStyle: { width: "50px" },
      text: t("redirect.smartHealth"),
      redirectText: t("redirect.goToApplication"),
      redirectImgSrc: RedirectImage,
      redirectImgAlt: "redirectImage",
      visibleLanguages:[languagesEnum.TR]
    },
    {
      href: "https://www.regal-tr.com/customer/login",
      imgSrc: regal1,
      imgAlt: "regal1",
      redirectText: t("redirect.goToWebsite"),
      redirectImgSrc: RedirectImage,
      redirectImgAlt: "redirectImage",
      visibleLanguages:[languagesEnum.TR]
    },
    {
      href: "https://www.vsoutlet.com.tr/customer/login",
      imgSrc: vsOutlet1,
      imgAlt: "vestelLogo1",
      redirectText: t("redirect.goToWebsite"),
      redirectImgSrc: RedirectImage,
      redirectImgAlt: "redirectImage",
      visibleLanguages:[languagesEnum.TR]
    },
    {
      href: process.env.REACT_APP_SUPPORT_URL,
      imgSrc: vestelCozum1,
      imgAlt: "vestelCozum1",
      redirectText: t("redirect.goToWebsite"),
      redirectImgSrc: RedirectImage,
      redirectImgAlt: "redirectImage",
      visibleLanguages:[languagesEnum.TR]
    },
  ];

  const renderInRows = (items) => {
    // Her iki öğeyi bir satıra yerleştirecek şekilde gruplandırıyoruz
    return items.reduce((acc, item, index) => {
      if (index % 3 === 0) {
        acc.push([item]);
      } else {
        acc[acc.length - 1].push(item);
      }
      return acc;
    }, []);
  };

  // Sadece geçerli dilde görünecek öğeleri filtreliyoruz
  const filteredItems = applicationList.filter(option =>
    option.visibleLanguages.includes(i18n.language)
  );

  const rows = renderInRows(filteredItems);

  useEffect(() => {
    if (i18n.language == "tr") {
      setStoreUrl(`${process.env.REACT_APP_STORE_URL}customer/login`);
    } else if (i18n.language == "de") {
      setStoreUrl(`${process.env.REACT_APP_GLOBAL_STORE_URL}customer/login`);
    }
  }, [i18n.language]);

  useEffect(() => {
    let userDevice = navigator.userAgent || window.opera;
    if (/iPad|iPhone|iPod/.test(userDevice) && !window.MSStream) {
      setEvinAkli("https://apps.apple.com/tr/app/evin-aklı/id966916050");
      setVfit("https://apps.apple.com/tr/app/vfit/id1491459940");
    } else {
      setEvinAkli(
        "https://play.google.com/store/apps/details?id=com.smarthome.core.main&hl=tr"
      );
      setVfit(
        "https://play.google.com/store/apps/details?id=com.vestel.vfitplus"
      );
    }
  });

  return (
    <div className="redirect-page">
      <div className="content-page identity-content-page">
        <div className="identity-overflow">
          <img
            className="vestel-kimlik-img"
            src={vestelKimlik}
            alt="vestel-kimlik"
          />
          <div>
            <div className="identity-position">
              VESTEL {t("redirect.title")}
            </div>
            <div className="identity-absolute">{t("redirect.description")}</div>
          </div>
        </div>
        <div
          style={{
            display: "block",
            position: "absolute",
            top: "110%",
          }}
        >
          <div>
            <img className="redirect-image" src={redirect1} alt="redirect1" />
          </div>
        </div>
        <div className="redirect-p-title">
          <p className="redirect-p-center">{t("redirect.now")},</p>
          <p className="redirect-p-center-bold">{t("redirect.youWantLogin")}</p>
          <p className="redirect-p-center-bold">
            {t("redirect.websiteOrApplication")}
          </p>
          <p className="redirect-p-center-bold">{t("redirect.click")}.</p>
          {isSmallScreen ? (
          <div className="applications-wrapper">
            {rows.map((row, rowIndex) => (
              <div className="sign-in-div" key={rowIndex}>
                {row.map((option, index) => (
                  <a key={index} href={option.href}>
                    <div className="sign-in-square">
                      <img
                        className="sign-in-img"
                        src={option.imgSrc}
                        alt={option.imgAlt}
                        style={option.imgStyle || {}}
                      />
                      {option.text && <p className="sign-in-img-p">{option.text}</p>}
                      <p className="sign-in-redirect-website">
                        {option.redirectText}
                        <img
                          src={option.redirectImgSrc}
                          alt={option.redirectImgAlt}
                        />
                      </p>
                    </div>
                  </a>
                ))}
              </div>
            ))}
          </div>
        ) : (
          <div className="applications-wrapper">
            <div className="sign-in-div">
              {applicationList.filter(app => app.visibleLanguages.includes(i18n.language)).map((app, index) => (
                <a key={index} href={app.href}>
                  <div className="sign-in-square">
                    <img
                      className="sign-in-img"
                      src={app.imgSrc}
                      alt={app.imgAlt}
                      style={app.imgStyle || {}}
                    />
                    {app.text && <p className="sign-in-img-p">{app.text}</p>}
                    <p className="sign-in-redirect-website">
                      {app.redirectText}
                      <img
                        src={app.redirectImgSrc}
                        alt={app.redirectImgAlt}
                      />
                    </p>
                  </div>
                </a>
              ))}
            </div>
          </div>
        )}
        </div>
      </div>
    </div>
  );
}
